import {
    Typography,
    Card,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    TextField,
    Table,
    TableCell,
} from '@mui/material';
import { Button } from '@mui/material';

export const ContentContainer = styled('div')({
    position: 'relative',
    minHeight: 'calc(100vh - 64px)',
    paddingBottom: '100px',
    overflowY: 'auto',
    marginLeft: 70
});

export const MainContent = styled('div')({
    padding: '20px',
    marginBottom: '20px',

});

export const CenteredCard = styled(Card)({
    maxWidth: '100%',
    margin: '20px',
    marginTop: '80px',
    borderBottom: '2px solid dodgerblue',
    marginBottom: '50px'
});

export const StyledTableHead = styled(TableCell)({
    fontWeight: 'bold',
    fontSize: '1rem',
    textAlign: 'center',
    backgroundColor: '#F5F5F5',
    padding: '5px',
    marginTop: '10px'
});

export const StyledTableCell = styled(TableCell)({
    fontSize: '16px',
    textAlign: 'center',
    padding: '8px',
});

export const HeaderTitle = styled(Typography)({
    flexGrow: 1,
    fontSize: '1.4rem',
    color: '#333',
    fontWeight: 'normal',
    textAlign: 'left',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
    marginLeft: '10px',
});

export const StyledTable = styled(Table)({
    borderCollapse: 'collapse',
    width: '100%',
});

export const RefreshIcon = styled('img')({
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'rotate(360deg)',
    },
});

export const CustomTextField = styled(TextField)({
    '& .MuiInput-root': {
        color: 'dodgerblue',
        fontSize: '1rem',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:before': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: 'dodgerblue',
    },
});

export const CustomButton = ({ onClick, children, startIcon, ...props }) => {
    return (
        <Button
            variant="outlined"
            sx={{
                background: 'primary',
                textTransform: 'none',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                '&:hover': {
                    background: 'solid dodgerblue',
                },
                marginRight: '10px',
            }}
            startIcon={startIcon}
            onClick={onClick}
            {...props}
        >
            {children}
        </Button>
    );
};